export default {
    GAVEKORT: "GAVEKORT",
    GAVEBILLET: "GAVEBILLET",
    GAVEBILLET_BARN: "GAVEBILLET BARN",
    GAVEBILLET_IMAX: "GAVEBILLET IMAX",
    GAVEBILLET_IMAX_BARN: "GAVEBILLET IMAX BARN",
    GAVEBILLET_LUKSUS: "GAVEBILLET LUKSUS",
    GAVE_MENU: "GAVEMENU",
    GAVE_MENU_BARN: "GAVEMENU BARN"
}